import { ModalActions } from "./ModalActions";
import { ModalContent } from "./ModalContent";
import { ModalHeader } from "./ModalHeader";
import { ModalIcon } from "./ModalIcon";
import { ModalRoot } from "./ModalRoot";

export const Modal = {
  Root: ModalRoot,
  Header: ModalHeader,
  Icon: ModalIcon,
  Content: ModalContent,
  Actions: ModalActions,
};
